export default __webpack_public_path__ + "static/media/icon_people.01652f2c.svg";